// extracted by mini-css-extract-plugin
export var discard = "_50-3";
export var muiTooltipTooltip = "_50-5";
export var notificationBar = "_50-2";
export var saveButtonHoverSlotWrapper = "_50-4";
export var show = "_50-1";
export var spacer = "_50-0";